import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Video } from 'components/video'
import { VideoLoop } from 'components/wide-graphics/video-loop'
import { Circles } from '../../circles'
import { Title } from '../../styled'
import VideoSrc from './assets/Loop_kryashens-new.mp4'

type Props = {}

export const Kryashens = forwardRef<HTMLDivElement, Props>((_, ref) => (
  <section>
    <VideoLoop url={VideoSrc} />

    <TextContainer ref={ref}>
      <Title data-menu-title="кто такие кряшены">Кто такие Кряшены?</Title>
      <Circles align="right">
        <p>
          Когда Русское государство завоевало и присоединило ханства, а Казань
          пала в XVI веке – татар массово обращали в православие. Так появилось
          понятие крещеных татар.
        </p>
        <p>
          Процесс смены веры на завоеванных землях начался с представителей
          местной знати, которая смогла таким образом подтвердить свою верность
          российскому государству и получить существенные привилегии от новой
          власти. Некоторые кряшены утверждают, что они – потомки тюркских
          племен, которые в VI веке сами приняли православие на территории
          Волжской Булгарии.
        </p>
        <p>
          После Октябрьской революции 1917 года крещеные татары хотели создать
          свою автономию. Новые татарские власти предоставили кряшенам только
          культурную автономию, но и этой привилегии старались их лишить. Мы
          посетили небольшое село Кряш-Серда, где проживают современные кряшены,
          и узнали, чем они отличаются от татар и почему не согласны называться
          одним народом.
        </p>
      </Circles>
    </TextContainer>
    <Circles align="left">
      <TextContainer>
        <Video
          id="W2OKi2E69-c"
          poster="https://gdb.currenttime.tv/01000000-c0a8-0242-a62d-08dc1602af90_w1280.jpg"
        />
      </TextContainer>
    </Circles>
  </section>
))
